<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/S14IBu/tc-custom/9780740790584.jpg?1729082544956" alt="This image is the cover for the book Silent But Deadly"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Silent But Deadly
      </h1>
      <p class="bookDescription body article font2">
        <p>This strip offers a fresh outlook and appeals to everyone . . . LIO is a comic strip that's edgy, funny, visually stunning, and truly different." --<i>Daily Cartoonist</i></p><p>With a feature film in the works from producer David Kirschner (<i>Child's Play, An American Tail</i>), LIO deftly melds the macabre with its brand of dark humor.</p><p>Having been distinguished by <i>Variety</i> as "a fast riser," Mark Tatulli's morbidly mirthful pantomime comic strip, LIO, is humorously astute and just slightly askew in its perception of the world.</p><p>Centered around an odd, ghostly-pale child named LIO, and his creepy coterie of friends, including a giant squid named Ishmael and a scythe-carrying grim reaper, LIO; is influenced by cartooning greats Gahan Wilson, Charles Addams, and 19th-century satirist A. J. Volck. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mark Tatulli
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0f514c1f